import { useCohortSyncPlanContext } from "@pathwright/web/src/modules/path/sync/SyncPlanContext"
import { ConnectStores } from "lib/core/store"
import { useEffect } from "react"

// hack replacement for path-publish-store storeTriggerHandlers
const SyncPathReloader = ({ cohortId }) => {
  const { refetchSyncPlanQueries } = useCohortSyncPlanContext({
    cohortId,
    // This fails due to the following error:
    // (Invariant Violation): cache-only fetchPolicy option should not be used together with query refetch.

    // This error is fixed in @apollo/client@3.2.0-beta.12
    // Related issue: https://github.com/apollographql/apollo-client/issues/6702

    // queryOptions: {
    //   fetchPolicy: "cache-only"
    // }

    // HACK: temp fix for preventing this query from occurring and subsequent refetch
    queryOptions: {
      skip: !(
        window.App && window.App.getStore("path").getState().mode === 15
      ) /* DESIGN */
    }
  })

  useEffect(() => {
    const model = new Backbone.Model()

    const eventHandlers = [
      {
        store: "pathAdmin",
        events: ["path:item:updated", "path:item:created", "path:item:archived"]
      },
      {
        store: "path",
        events: ["path:items:reordered"]
      },
      {
        store: "contentAdmin",
        events: ["content:updated"]
      },
      {
        store: "step",
        events: ["change:downloads"]
      }
    ]

    // hook up event handlers
    eventHandlers.forEach(({ store, events }) =>
      events.forEach((_event) =>
        model.listenTo(App.getStore(store), _event, () =>
          refetchSyncPlanQueries()
        )
      )
    )

    // simply stop listening to all events
    return () => model.stopListening()
  }, [refetchSyncPlanQueries])

  return null
}

SyncPathReloader.displayName = "SyncPathReloader"

const mapStateToProps = (state, ownProps) => {
  const { offering } = state.resourceStore.state
  return {
    ...ownProps,
    cohortId: offering && offering.id
  }
}

const stores = [{ store: "resource", watch: ["offering"] }]

export default ConnectStores(SyncPathReloader, stores, {}, mapStateToProps)
